import { useFetch } from "@/lib/axios.config.ts";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { boom } from "@/lib/exposion";
import showCustomToast from "@/shared/utils/showCustomToast.ts";

interface BuyChancesPayload {
  opportunities: number;
}

const buyChances = async (challengeId: string, payload: BuyChancesPayload) => {
  try {
    const response = await useFetch.post(
      `/challenges/ChallengeOpportunity/${challengeId}`,
      payload
    );
    return response.data;
  } catch (error) {
    // Standardize error handling
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message ||
          "Something went wrong while buying chances"
      );
    }
    throw error;
  }
};

export const useBuyChancesMutation = (chanceValue: number) => {
  const { t } = useTranslation();
  return useMutation<
    string,
    undefined,
    { challengeId: string; opportunities: number }
  >({
    mutationFn: ({ challengeId, opportunities }) => {
      return buyChances(challengeId, { opportunities });
    },

    onSuccess: () => {
      // Success toast
      showCustomToast(
        t("challenge.chances_increased", {
          count: chanceValue,
        }),
        "success"
      );
      boom(false);
    },
  });
};
